// extracted by mini-css-extract-plugin
export default {"uploads-page":"uploadsPage_uploads-page__RfmWO","upload-buttons":"uploadsPage_upload-buttons__XT3E6"};